import { CheckCircle } from 'lucide-react';

/**
 * Page de confirmation affichée après un paiement réussi.
 */
export function PaymentSuccess() {
  return (
    <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-8 tw-max-w-md tw-w-full tw-text-center">
        <CheckCircle className="tw-w-16 tw-h-16 tw-text-green-500 tw-mx-auto tw-mb-4" />
        <h1 className="tw-text-xl tw-font-bold tw-text-gray-900 tw-mb-2">
          Paiement confirmé
        </h1>
        <p className="tw-text-gray-600 tw-mb-4">
          Votre paiement a été enregistré avec succès. Vous pouvez fermer cette page.
        </p>
        <div className="tw-bg-green-50 tw-border tw-border-green-200 tw-rounded-lg tw-p-4">
          <p className="tw-text-sm tw-text-green-800 tw-mb-0">
            Un email de confirmation vous sera envoyé prochainement.
          </p>
        </div>
      </div>
    </div>
  );
}
